"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-underscore-dangle */
var react_1 = __importStar(require("react"));
var emotion_theming_1 = require("emotion-theming");
var addons_1 = __importDefault(require("@storybook/addons"));
var core_events_1 = __importDefault(require("@storybook/core-events"));
var channels_1 = __importDefault(require("@storybook/channels"));
var channel_websocket_1 = __importDefault(require("@storybook/channel-websocket"));
var client_api_1 = require("@storybook/client-api");
var OnDeviceUI_1 = __importDefault(require("./components/OnDeviceUI"));
var StoryView_1 = __importDefault(require("./components/StoryView"));
var theme_1 = require("./components/Shared/theme");
// @ts-ignore
var rn_host_detect_1 = __importDefault(require("./rn-host-detect"));
var STORAGE_KEY = 'lastOpenedStory';
var Preview = /** @class */ (function () {
    function Preview() {
        var _this = this;
        this.api = function () {
            return _this._clientApi;
        };
        this.configure = function (loadStories, module) {
            loadStories();
            if (module && module.hot) {
                module.hot.accept(function () { return _this._sendSetStories(); });
                // TODO remove all global decorators on dispose
            }
        };
        this.getStorybookUI = function (params) {
            if (params === void 0) { params = {}; }
            var webUrl = null;
            var channel = null;
            if (params.asyncStorage === undefined) {
                // eslint-disable-next-line no-console
                console.warn("\nStarting Storybook v5.3.0, we require to manually pass an asyncStorage prop. Pass null to disable or use one from @react-native-community or react-native itself.\n\nMore info: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#react-native-async-storage\n      ".trim());
            }
            if (params.asyncStorage) {
                _this._asyncStorage = params.asyncStorage;
            }
            var onDeviceUI = params.onDeviceUI !== false;
            var initialSelection = params.initialSelection, shouldPersistSelection = params.shouldPersistSelection;
            try {
                channel = addons_1.default.getChannel();
            }
            catch (e) {
                // getChannel throws if the channel is not defined,
                // which is fine in this case (we will define it below)
            }
            if (!channel || params.resetStorybook) {
                if (onDeviceUI && params.disableWebsockets) {
                    channel = new channels_1.default({ async: true });
                    _this._setInitialStory(initialSelection, shouldPersistSelection);
                }
                else {
                    var host = rn_host_detect_1.default(params.host || 'localhost');
                    var port = ":" + (params.port || 7007);
                    var query = params.query || '';
                    var secured = params.secured;
                    var websocketType = secured ? 'wss' : 'ws';
                    var httpType = secured ? 'https' : 'http';
                    var url = websocketType + "://" + host + port + "/" + query;
                    webUrl = httpType + "://" + host + port;
                    channel = channel_websocket_1.default({
                        url: url,
                        async: onDeviceUI,
                        onError: function () {
                            _this._setInitialStory(initialSelection, shouldPersistSelection);
                        },
                    });
                }
                addons_1.default.setChannel(channel);
                _this._stories.setChannel(channel);
                channel.emit(core_events_1.default.CHANNEL_CREATED);
            }
            channel.on(core_events_1.default.GET_STORIES, function () { return _this._sendSetStories(); });
            channel.on(core_events_1.default.SET_CURRENT_STORY, function (d) { return _this._selectStoryEvent(d); });
            _this._sendSetStories();
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var preview = _this;
            addons_1.default.loadAddons(_this._clientApi);
            var appliedTheme = __assign(__assign({}, theme_1.theme), params.theme);
            // react-native hot module loader must take in a Class - https://github.com/facebook/react-native/issues/10991
            return /** @class */ (function (_super) {
                __extends(StorybookRoot, _super);
                function StorybookRoot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                StorybookRoot.prototype.render = function () {
                    if (onDeviceUI) {
                        return (react_1.default.createElement(emotion_theming_1.ThemeProvider, { theme: appliedTheme },
                            react_1.default.createElement(OnDeviceUI_1.default, { stories: preview._stories, url: webUrl, isUIHidden: params.isUIHidden, tabOpen: params.tabOpen, shouldDisableKeyboardAvoidingView: params.shouldDisableKeyboardAvoidingView, keyboardAvoidingViewVerticalOffset: params.keyboardAvoidingViewVerticalOffset })));
                    }
                    return (react_1.default.createElement(emotion_theming_1.ThemeProvider, { theme: appliedTheme },
                        react_1.default.createElement(StoryView_1.default, { stories: preview._stories, url: webUrl })));
                };
                return StorybookRoot;
            }(react_1.PureComponent));
        };
        this._setInitialStory = function (initialSelection, shouldPersistSelection) {
            if (shouldPersistSelection === void 0) { shouldPersistSelection = true; }
            return __awaiter(_this, void 0, void 0, function () {
                var story;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this._getInitialStory(initialSelection, shouldPersistSelection)()];
                        case 1:
                            story = _a.sent();
                            if (story) {
                                this._selectStory(story);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        this._getInitialStory = function (initialSelection, shouldPersistSelection) {
            if (shouldPersistSelection === void 0) { shouldPersistSelection = true; }
            return function () { return __awaiter(_this, void 0, void 0, function () {
                var story, value, _a, _b, e_1, stories;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            story = null;
                            if (!(initialSelection && this._checkStory(initialSelection))) return [3 /*break*/, 1];
                            story = initialSelection;
                            return [3 /*break*/, 6];
                        case 1:
                            if (!shouldPersistSelection) return [3 /*break*/, 6];
                            _c.label = 2;
                        case 2:
                            _c.trys.push([2, 5, , 6]);
                            value = this._asyncStorageStoryId;
                            if (!(!value && this._asyncStorage)) return [3 /*break*/, 4];
                            _b = (_a = JSON).parse;
                            return [4 /*yield*/, this._asyncStorage.getItem(STORAGE_KEY)];
                        case 3:
                            value = _b.apply(_a, [_c.sent()]);
                            this._asyncStorageStoryId = value;
                            _c.label = 4;
                        case 4:
                            if (this._checkStory(value)) {
                                story = value;
                            }
                            return [3 /*break*/, 6];
                        case 5:
                            e_1 = _c.sent();
                            return [3 /*break*/, 6];
                        case 6:
                            if (story) {
                                return [2 /*return*/, this._getStory(story)];
                            }
                            stories = this._stories.raw();
                            if (stories && stories.length) {
                                return [2 /*return*/, this._getStory(stories[0].id)];
                            }
                            return [2 /*return*/, null];
                    }
                });
            }); };
        };
        this._addons = {};
        this._decorators = [];
        this._stories = new client_api_1.StoryStore({ channel: null });
        this._clientApi = new client_api_1.ClientApi({ storyStore: this._stories });
    }
    Preview.prototype._sendSetStories = function () {
        var channel = addons_1.default.getChannel();
        var stories = this._stories.extract();
        channel.emit(core_events_1.default.SET_STORIES, { stories: stories });
        channel.emit(core_events_1.default.STORIES_CONFIGURED);
    };
    Preview.prototype._getStory = function (storyId) {
        return this._stories.fromId(storyId);
    };
    Preview.prototype._selectStoryEvent = function (_a) {
        var storyId = _a.storyId;
        if (storyId) {
            if (this._asyncStorage) {
                this._asyncStorage.setItem(STORAGE_KEY, JSON.stringify(storyId)).catch(function () { });
            }
            var story = this._getStory(storyId);
            this._selectStory(story);
        }
    };
    Preview.prototype._selectStory = function (story) {
        var channel = addons_1.default.getChannel();
        this._stories.setSelection({ storyId: story.id, viewMode: 'story' }, null);
        channel.emit(core_events_1.default.SELECT_STORY, story);
    };
    Preview.prototype._checkStory = function (storyId) {
        if (!storyId) {
            return null;
        }
        var story = this._getStory(storyId);
        if (story.storyFn === null) {
            return null;
        }
        return story;
    };
    return Preview;
}());
exports.default = Preview;
